module.exports = __webpack_public_path__ + "img/tbq-thumbnail.fcf43a0a.webp";